import React from 'react';
export function TermsAndConditions() {
  return <div className="prose prose-sm max-w-none" data-id="element-655">
      <p className="text-gray-600 mb-4" data-id="element-656">
        <strong data-id="element-657">Última actualización:</strong> Enero 2025
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-658">1. Aceptación de Términos</h3>
      <p className="text-gray-700 mb-4" data-id="element-659">
        Al comprar y utilizar el Sistema 50 Recetas Express, aceptas estos
        términos y condiciones. Si no estás de acuerdo, por favor no utilices
        nuestro producto.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-660">
        2. Descripción del Producto
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-661">
        El Sistema 50 Recetas Express es un producto digital que incluye:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-662">
        <li data-id="element-663">120+ recetas de 15 minutos en formato PDF</li>
        <li data-id="element-664">12 menús semanales completos</li>
        <li data-id="element-665">Guía de Batch Cooking Express</li>
        <li data-id="element-666">Listas de compras imprimibles</li>
        <li data-id="element-667">Guía de swaps por país</li>
        <li data-id="element-668">Acceso a comunidad privada</li>
        <li data-id="element-669">Actualizaciones mensuales</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-670">3. Licencia de Uso</h3>
      <p className="text-gray-700 mb-4" data-id="element-671">
        Al comprar el sistema, obtienes una licencia personal y no transferible
        para:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-672">
        <li data-id="element-673">Usar el contenido para tu uso personal y familiar</li>
        <li data-id="element-674">Imprimir las recetas para uso doméstico</li>
        <li data-id="element-675">Acceder a las actualizaciones incluidas</li>
      </ul>
      <p className="text-gray-700 mb-4" data-id="element-676">
        <strong data-id="element-677">NO está permitido:</strong>
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-678">
        <li data-id="element-679">Compartir, revender o distribuir el contenido</li>
        <li data-id="element-680">
          Publicar las recetas en sitios web o redes sociales sin autorización
        </li>
        <li data-id="element-681">Usar el contenido con fines comerciales</li>
        <li data-id="element-682">Modificar y redistribuir el material</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-683">4. Garantía de 30 Días</h3>
      <p className="text-gray-700 mb-4" data-id="element-684">
        Ofrecemos una garantía de satisfacción de 30 días. Si implementas el
        sistema durante un mes y no estás satisfecho, te devolvemos el 100% de
        tu inversión. Para solicitar un reembolso:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-685">
        <li data-id="element-686">Envía un email a recetasexpresslatam@gmail.com</li>
        <li data-id="element-687">Indica tu número de orden</li>
        <li data-id="element-688">El reembolso se procesará en 5-7 días hábiles</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-689">
        5. Descargo de Responsabilidad
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-690">Los resultados pueden variar según:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-691">
        <li data-id="element-692">La consistencia de implementación del sistema</li>
        <li data-id="element-693">Habilidades culinarias previas</li>
        <li data-id="element-694">Disponibilidad de ingredientes en tu región</li>
        <li data-id="element-695">Equipamiento de cocina disponible</li>
      </ul>
      <p className="text-gray-700 mb-4" data-id="element-696">
        Las recetas están diseñadas para personas sin restricciones alimentarias
        graves. Si tienes alergias o condiciones médicas específicas, consulta
        con un profesional de la salud antes de implementar cambios en tu dieta.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-697">6. Propiedad Intelectual</h3>
      <p className="text-gray-700 mb-4" data-id="element-698">
        Todo el contenido del Sistema 50 Recetas Express está protegido por
        derechos de autor. Nos reservamos todos los derechos sobre el material.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-699">7. Modificaciones</h3>
      <p className="text-gray-700 mb-4" data-id="element-700">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán notificados a través de email y actualizados
        en esta página.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-701">8. Contacto</h3>
      <p className="text-gray-700 mb-4" data-id="element-702">
        Para consultas sobre estos términos:
        <br data-id="element-703" />
        <strong data-id="element-704">Email:</strong> recetasexpresslatam@gmail.com
        <br data-id="element-705" />
        <strong data-id="element-706">Soporte:</strong> recetasexpresslatam@gmail.com
      </p>
    </div>;
}